// Implements: F-IDN-010
/** Below the session table: "only this device" when no other session is open, and the DB-IP credit. */

import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import { GeoAttribution } from "./GeoAttribution";
import shared from "./account.module.css";

export interface SessionsFooterProps {
  readonly others: number;
}

export function SessionsFooter({ others }: SessionsFooterProps): ReactElement {
  const { t } = useTranslation();
  return (
    <>
      {others === 0 ? <p className={shared.help}>{t("account.sessions.onlyThis")}</p> : null}
      <GeoAttribution />
    </>
  );
}
